import Spinner from 'react-spinkit';
import styles from './SCSS/SpinnerOverlay.module.scss';
import utilityStyles from './SCSS/common/utilityStyles.module.scss';

interface Props {
  isShow: boolean;
  message?: string;
}

export const SpinnerOverlay = ({ isShow, message }: Props) =>
  !isShow ? null : (
    <div className={styles.spinnerWrapper}>
      <div className={`${utilityStyles.absCentre} vcenter ${styles.spinner}`}>
        <Spinner name='three-bounce' />
        {message && (
          <div className={styles.message} role='status' aria-live='polite' aria-atomic='true'>
            {message}
          </div>
        )}
      </div>
    </div>
  );

export default SpinnerOverlay;
